import React, {useMemo} from "react";
import { Link } from "react-router-dom";
import {useHtmlClassService} from "../../_core/MetronicLayout";

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  return (
    <div
      className={`footer bg-white py-4 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted font-weight-bold mr-2">{today.toString()}</span> &copy;{" "}
          <span className="text-dark-75 mr-2">Link For All</span>
          <span className="text-muted font-weight-bold mr-1">| Developed by</span>
          <a
            href="https://whizpool.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-75 text-hover-primary"
          >
            Whizpool
          </a>
        </div>
        <div className="nav nav-dark order-1 order-md-2">
          <Link
            to="/privacy"
            target="_blank"
            className="nav-link pr-3 pl-0 text-dark-75 text-hover-primary"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
}
